import { supabase } from "@/shared/lib/supabase";
import { sentryUtils } from "@/shared/utils/sentry";

interface SaveProfilePictureArgs {
  fileKey: string;
  contactId: number;
  userId: number | null;
}

export async function saveProfilePicture({
  fileKey,
  contactId,
  userId,
}: SaveProfilePictureArgs): Promise<void> {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const accessToken = session?.access_token;
    if (!accessToken) return;

    await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/media/profile-picture/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      },
      body: JSON.stringify({ fileKey, contactId, userId }),
    });
  } catch (error) {
    console.error("Failed to save profile picture metadata:", error);
    // Don't fail the entire contact creation if profile picture save fails
    sentryUtils.captureError(
      error,
      "Failed to save profile picture metadata",
      { userId: userId ?? undefined },
      "warning",
    );
  }
}
